import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const nebulaStatisticsMenuRegistry = {
    personalize_nebulaStatistics: {
        label: "Nebula Statistics",
        link: PAGE_URL.NEBULA_STATISTICS_PAGE,
        key: PAGE_URL.NEBULA_STATISTICS_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default nebulaStatisticsMenuRegistry;
